import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class CarRegistrationService {
  constructor(private http: HttpUtilService) {}

  getDetails(contractNo: string): Observable<any> {
    return this.http.get(
      `CarRegistrationService.asmx/GetDetails?contractNo=%22${contractNo}%22`,
    );
  }

  checkVinSeriesExist(vin: string): Observable<any> {
    return this.http.post(
      "CarRegistrationService.asmx/CheckVinSeriesExist",
      {
        VinNo: vin,
      },
    );
  }

  update(payload: any): Observable<any> {
    return this.http.post("CarRegistrationService.asmx/Update", {
      model: payload,
    });
  }

  updateRetention(Name: string, Value: string): Observable<any> {
    return this.http.post(
      "CarRegistrationService.asmx/UpdateRetention",
      {
        model: { Name: Name, Value: Value },
      },
    );
  }

  getDeliveryCertificate(ContractNo: string): Observable<any> {
    return this.http.post(
      "CarRegistrationService.asmx/GetDeliveryCertificate",
      {
        model: { ContractNo },
      },
    );
  }

  updateFullDoc(contractNo: string): Observable<any> {
    return this.http.post(
      "CarRegistrationService.asmx/UpdateFullDoc",
      {
        contractNo,
      },
    );
  }
}
